import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const getTeamRoles = async () => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.get(`${FIRMFLOWURL}api/TeamRole`, {
            headers: { Authorization: token },
        });

        return { ...response, success: true };
    } catch (err) {
        console.log(err);
        if (err.message.includes(401)) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return;
        }
        return {
            success: false,
            status: err.response?.status,
            data: err.response?.data,
            message: err.response?.data?.message ?? err.message,
        };
    }
};

const teamRoleRequest = async (method, url, payload) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios({
            method,
            url: `${FIRMFLOWURL}${url}`,
            data: payload,
            headers: { Authorization: token },
        });

        return { ...response, success: true };
    } catch (err) {
        console.log(err);
        if (err.response?.status === 401 || err.message.includes(401)) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return;
        }
        return {
            success: false,
            status: err.response?.status,
            data: err.response?.data,
            message: err.response?.data?.message ?? err.message,
        };
    }
};

export const createTeamRole = (teamRole) =>
    teamRoleRequest("post", "api/TeamRole", teamRole);

export const updateTeamRole = (teamRoleId, teamRole) =>
    teamRoleRequest("put", `api/TeamRole/${teamRoleId}`, teamRole);

export const reorderTeamRoles = (roles) =>
    teamRoleRequest("put", "api/TeamRole/order", { roles });

export const updateTeamRoleColors = (teamRoles) =>
    teamRoleRequest("put", "api/TeamRole/colors", { teamRoles });

export const deleteTeamRole = (teamRoleId) =>
    teamRoleRequest("delete", `api/TeamRole/${teamRoleId}`);
